import { isMobile } from "common/utils/browser";
import initSlider from "common/utils/ui/slider";
import initSoftnessScore from "components/compositions/softness_score/component";

import "./product-details-similar-products.scss";

export const initScroll = parent => {
  if (isMobile()) {
    return false;
  }

  return initSlider({
    parent,
    list: ".js-similar-list",
    grid: ".js-similar-grid",
    arrowLeft: ".js-similar-scroll-left",
    arrowRight: ".js-similar-scroll-right",
    hiddenClass: "product-details-similar-products__arrow-disabled"
  });
};

export default () => {
  initScroll();
  initSoftnessScore();
};
